export const THEMES = {
  LIGHT: 'LIGHT',
  DARK: 'DARK',
  NATURE: 'NATURE',
  TOPBAR: 'TOPBAR',
  CUSTOM: 'CUSTOM',
  MOBILE: 'MOBILE',
  TOPBARMOBILE: 'TOPBARMOBILE'
};
